(() => {
  const boot = () => {
    document.querySelectorAll('[data-nrnl-hero-carousel]').forEach((root) => {
      if (root.dataset.nrnlCarouselReady === 'true') return;
      root.dataset.nrnlCarouselReady = 'true';

      const slides = Array.from(root.querySelectorAll('[data-nrnl-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-nrnl-hero-dot]'));
      const prev = root.querySelector('[data-nrnl-hero-prev]');
      const next = root.querySelector('[data-nrnl-hero-next]');
      const pause = root.querySelector('[data-nrnl-hero-pause]');
      const pauseIcon = root.querySelector('[data-nrnl-pause-icon]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Math.max(4000, Number(root.dataset.interval) || 6000);
      let index = 0;
      let timer = null;
      let userPaused = false;
      let pointerInside = false;
      let focusInside = false;

      const clearTimer = () => {
        if (timer) window.clearTimeout(timer);
        timer = null;
      };

      const updatePause = () => {
        if (!pause) return;
        pause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pause.setAttribute('aria-label', userPaused ? 'Play hero carousel' : 'Pause hero carousel');
        if (pauseIcon) pauseIcon.textContent = userPaused ? '▶' : 'Ⅱ';
      };

      const show = (nextIndex) => {
        if (!slides.length) return;
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const schedule = () => {
        clearTimer();
        if (reducedMotion || userPaused || pointerInside || focusInside || document.hidden || slides.length < 2) return;
        timer = window.setTimeout(() => {
          show(index + 1);
          schedule();
        }, interval);
      };

      prev?.addEventListener('click', () => { show(index - 1); schedule(); });
      next?.addEventListener('click', () => { show(index + 1); schedule(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slideIndex) || 0); schedule(); }));
      pause?.addEventListener('click', () => {
        userPaused = !userPaused;
        updatePause();
        schedule();
      });

      root.addEventListener('pointerenter', () => { pointerInside = true; clearTimer(); });
      root.addEventListener('pointerleave', () => { pointerInside = false; schedule(); });
      root.addEventListener('focusin', () => { focusInside = true; clearTimer(); });
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) {
          focusInside = false;
          schedule();
        }
      });
      document.addEventListener('visibilitychange', schedule);

      show(0);
      updatePause();
      schedule();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
